import * as React from "react";
import {Link} from "gatsby";
import {StaticImage} from "gatsby-plugin-image";
import Photos from "./photos";

export const projectsData = [
    {
        name: "Projects",
        companyName: "Coin Metrics",
        companyLink: "https://coinmetrics.io",
        body: <ul className="list ml-2">
            <li>Chain Monitor (Farum);</li>
            <li>Universal Blockchain Explorer API (Atlas);</li>
            <li>Interactive HTML demos;</li>
            <li>Distributed rate limiter for API calls;</li>
            <li>Access Management System for APIs;</li>
            <li>Coin Metrics API v4.</li>
        </ul>,
        stack: ["Kotlin", "Postgres", "HTML/CSS/JS"],
        years: [2019],
        role: "VP of Engineering"
    },
    {
        name: "AppMetr",
        companyName: "Pixonic",
        companyLink: "https://pixonic.com",
        body: <p>The architecture of in-house distributed, high-load, fault-tolerant analytical system AppMetr. It handles more than 1 billion events per day, stores more than 100 Tb of data.</p>,
        fullBody: <React.Fragment>
            <p>The architecture of in-house distributed, high-load, fault-tolerant analytical system AppMetr. It handles more than 1 billion events per day, stores more than 100 Tb of data.</p>
            <p>The main features are an efficient in-house columnar database (I've created it), near real-time analytics, schemaless custom events, powerful UI for the end-users.</p>
            <p>The system provides a fast way to filter, group, analyze a huge amount of events from mobile devices and servers in seconds. It allows inspecting the lifecycle of an individual user or some user group. Besides base features, it provides advanced analytics like cohort analysis, user retention analysis, etc.</p>
            <p>We use Apache Cassandra as cold storage, Apache Kafka for queues, and in-house Java software for high-performance querying.</p>
            <p>You can get more details from this <a href="https://www.youtube.com/watch?v=F_moPIR-cNU" target="_blank" rel="nofollow">video</a> or other videos in the <Link to="/media/">media section</Link>.</p>
            <p>Managed a team of 5 Software Engineers.</p>
            <p>Was a speaker at Saint HighLoad++ 2019 and Joker 2019 conferences.</p>
        </React.Fragment>,
        more: "appmetr",
        stack: ["Java", "Apache Cassandra"],
        years: [2016, 2019],
        role: "Lead Software Engineer / Team Lead"
    },
    {
        name: "Chatovod",
        body: <React.Fragment>
            <p>The most popular Russian chat room service.</p>
            <p>International version: <a target="_blank" rel="nofollow" href="https://chatovod.com">chatovod.com</a></p>
            <p>Russian version: <a target="_blank" rel="nofollow" href="https://chatovod.ru">chatovod.ru</a></p>
        </React.Fragment>,
        stack: ["Java/Kotlin", "MySQL", "HTML/CSS/JS"],
        years: [2009],
        role: "Founder"
    },
    {
        name: "SkyPetr",
        companyName: "VS Lab",
        body: <p>
            A distributed system for collecting and analyzing publicly available information on the Internet.
        </p>,
        stack: ["Java", "HTML/CSS/JS"],
        years: [2009, 2010],
        role: "Lead Java Developer"
    },
    {
        name: "BestPersons.ru",
        body: <p>More than a social aggregator.</p>,
        fullBody: <div className="space-y-4">
            <div className="text-center">
                <StaticImage alt="BestPersons.ru logo" src="../images/bp/logo.png" className="my-2"/>
            </div>
            <p className="text-center">More than a social aggregator.</p>
            <Photos name="bp"/>
            <div className="aspect-w-16 aspect-h-9">
                <iframe src="https://www.youtube.com/embed/cv6Y0f8EHB4"
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen/>
            </div>
            <p>Unfortunately, the project is <Link to="/ru/news/2021-08-07-bp-is-closed">closed</Link>.</p>
        </div>,
        more: "bp",
        stack: ["Java", "HTML/CSS/JS"],
        years: [2007, 2009],
        role: "Founder"
    },
    {
        name: "City Chat / Space Doors / CD.RU",
        body: <React.Fragment>
            <p>A cross-platform social network.</p>
            <p>Some insight can be found <a href="https://vc.ru/life/64998-kak-my-sdelali-analog-whatsapp-v-rossii-v-nulevye" target="_blank" rel="nofollow">here</a>.</p>
        </React.Fragment>,
        stack: ["Java", "HTML/CSS/JS", "J2ME", "Symbian"],
        years: [2005, 2008],
        role: "Lead Java Developer / Team Lead"
    },
    {
        name: "Pushkino.info",
        body: <p>Pushkino city website (pushkino.org).<br/>
            Online stores (shop.pushkino.info).<br/>
            Internet Club management software.</p>,
        stack: ["Java", "PHP", "HTML/CSS/JS"],
        years: [2003, 2005],
        role: "Lead Software Engineer"
    },
    {
        name: "Freelance projects",
        body: <p>Development and sale of own software and websites.</p>,
        stack: ["Java", "PHP", "VB", "HTML/CSS/JS"],
        years: [2000, 2003]
    }
]